import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { capitalize } from '@mui/material/utils';

interface IProps {
  color: 'default';
  height: number;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    '&.colorDefault': {
      backgroundColor: theme.palette.background.default,
    },
  },
}));

const StepperBackground: React.FC<React.PropsWithChildren<IProps>> = ({ color, height }) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(`color${capitalize(color)}`, classes.root)}
      style={{
        height,
      }}
    />
  );
};

export default memo(StepperBackground);
